export default __webpack_public_path__ + "static/media/ic_twitter_fill.20ac4781.svg";